import {
    addDays,
    formatDayLabel,
    fromDayKey,
    startOfDay
} from '@/lib/carwash/format'

export type DateRange = {
    start: number
    end: number
}

export const DATE_PRESETS: { value: string, label: string }[] = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: '7d', label: 'Last 7 days' },
    { value: '30d', label: 'Last 30 days' },
    { value: 'all', label: 'All time' }
]

const DAY_KEY = /^\d{4}-\d{2}-\d{2}$/

export const isDateFilter = (value: string): boolean => value === 'all' || DATE_PRESETS.some(preset => preset.value === value) || DAY_KEY.test(value)

/* Turns a date filter ("today", "7d", "2026-10-31") into a time range, or null for all time. */
export const resolveDateFilter = (filter: string, now: number): DateRange | null => {
    if (filter === 'all') return null

    const today = startOfDay(now)
    const day = (offset: number) => addDays(today, offset).getTime()

    switch (filter) {
        case 'yesterday': return { start: day(-1), end: day(0) }
        case '7d': return { start: day(-6), end: day(1) }
        case '30d': return { start: day(-29), end: day(1) }
        case 'today': return { start: day(0), end: day(1) }
        default: {
            if (!DAY_KEY.test(filter)) return { start: day(0), end: day(1) }

            const start = fromDayKey(filter)
            return { start: start.getTime(), end: addDays(start, 1).getTime() }
        }
    }
}

export const describeDateFilter = (filter: string, now: number): string => {
    const preset = DATE_PRESETS.find(item => item.value === filter)
    if (preset) return preset.label
    if (DAY_KEY.test(filter)) return formatDayLabel(fromDayKey(filter), now)
    return 'Today'
}

export const inDateRange = (value: string | null, range: DateRange | null): boolean => {
    if (!range) return true
    if (!value) return false

    const time = new Date(value).getTime()
    return time >= range.start && time < range.end
}
